import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the person has asked their system for less movement.
 *
 * The stylesheet already honours this for the decorative animations. This
 * hook is for the movement CSS cannot reach: the swipe card is transformed
 * from JavaScript on every pointer move, so its rotation has to be dropped
 * here or not at all.
 */
export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia(QUERY).matches;
  } catch {
    // No matchMedia (old browsers, some test environments): assume the
    // ordinary case rather than crippling the animation for everybody.
    return false;
  }
}

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(prefersReducedMotion);

  useEffect(() => {
    let query: MediaQueryList;
    try {
      query = window.matchMedia(QUERY);
    } catch {
      return;
    }
    const update = () => setReduced(query.matches);
    update();
    // `addEventListener` on a MediaQueryList is Safari 14+; the app's floor is
    // iOS 16, so the deprecated `addListener` fallback is not needed.
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return reduced;
}
